module.exports = __webpack_public_path__ + "img/sword-arthur.226fb6ea.jpg";